import { Provider } from 'vuex-react'
import { getQuickEncryptionConfig } from '../lib/cryptic'

export const ConfigProvider = ({ children }) => {
  const store = {
    encryptionConfig: {
      state: {
        config: getQuickEncryptionConfig('array'),
      },
    },
    network: {
      state: {
        isOnline: window.navigator.onLine,
      },
    },
  }
  
  return (
    <Provider store={store} >
      {children}
    </Provider>
  )
}
